export default "__VITE_ASSET__G69xl_$K__"